export default "__VITE_ASSET__CfDERpoz__"